/* SPDX-License-Identifier: AGPL-3.0-or-later */

import {LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {UserLoginComponent} from './components/login/user-login.component';
import {UserRegisterComponent} from './components/user-register/user-register.component';
import {httpInterceptorProviders} from './interceptors';
import {MatToolbar} from '@angular/material/toolbar';
import {MatIcon, MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatButton, MatButtonModule, MatIconButton} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatCardModule} from '@angular/material/card';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {UserDetailComponent} from './components/user-detail/user-detail.component';
import {UserEditDetailsFormComponent} from './components/user-edit-details-form/user-edit-details-form.component';
import {UpdateUserComponent} from './components/update-user/update-user.component';
import {AuthLayoutComponent} from './layouts/auth-layout/auth-layout.component';
import {MainLayoutComponent} from './layouts/main-layout/main-layout.component';
import {MatListModule, MatNavList} from '@angular/material/list';
import {MatDivider} from '@angular/material/divider';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import localeDe from '@angular/common/locales/de';
import {NgOptimizedImage, registerLocaleData} from '@angular/common';

registerLocaleData(localeDe);
import {ConfirmDialogComponent} from './components/confirm-dialog/confirm-dialog.component';
import {MatInputModule} from '@angular/material/input';
import {CommonModule} from '@angular/common';
import {TeamSignupComponent} from './components/tournament/team-signup/team-signup.component';
import {TournamentsComponent} from './components/tournament/tournaments/tournaments.component';
import {TournamentCardComponent} from './components/tournament/tournament-card/tournament-card.component';
import {CopyLinkDialogComponent} from './components/copy-link-dialog/copy-link-dialog.component';
import {TournamentOverviewComponent} from './components/tournament/tournament-overview/tournament-overview.component';
import {TournamentTeamEditComponent} from './components/tournament-team-edit/tournament-team-edit.component';
import {MatTable} from '@angular/material/table';
import {MatDatepicker} from '@angular/material/datepicker';
import {HeaderCardComponent} from './components/header-card/header-card.component';
import {BrowserModule} from '@angular/platform-browser';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

@NgModule({
    // Keep alphabetically sorted!
    declarations: [
        AppComponent,
        AuthLayoutComponent,
        ConfirmDialogComponent,
        CopyLinkDialogComponent,
        MainLayoutComponent,
        SidebarComponent,
        TeamSignupComponent,
        TournamentCardComponent,
        TournamentOverviewComponent,
        TournamentTeamEditComponent,
        TournamentsComponent,
        UpdateUserComponent,
        UserDetailComponent,
        UserEditDetailsFormComponent,
        UserLoginComponent,
        UserRegisterComponent,
    ],
    bootstrap: [AppComponent],
    // Keep alphabetically sorted!
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        BrowserModule,
        ClipboardModule,
        CommonModule,
        FormsModule,
        HeaderCardComponent,
        MatButton,
        MatButtonModule,
        MatCardModule,
        MatDatepicker,
        MatDialogModule,
        MatDivider,
        MatFormFieldModule,
        MatIcon,
        MatIconButton,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatNavList,
        MatProgressSpinnerModule,
        MatSidenavModule,
        MatTable,
        MatToolbar,
        MatTooltipModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatSelect,
        MatOption,
        NgOptimizedImage
    ],
    providers: [
        httpInterceptorProviders,
        {
            provide: MatDialogRef,
            useValue: {},
        },
        {
            provide: LOCALE_ID,
            useValue: 'de-AT',
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {
}
